import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import Topbar from "./topbar/Topbar";
import Sidebar from "./sidebar/Sidebar";
import CertSelect from "./certSelect/CertSelect";
import SurveyPopup from "../surveyPopup/SurveyPopup";
import pagePath from "../../util/constants/pagePath";
import { handleSignout } from "../../util/functions/handleSignout";
import "./layout.css";

const Layout = ({ children }) => {
  const { signedIn } = useSelector((state) => state.user);
  const [colorMode, setColorMode] = useState(() => {
    if (typeof window === "undefined") return "light";
    return window.localStorage.getItem("wnp-color-mode") === "dark" ? "dark" : "light";
  });
  const theme = useMemo(() => createTheme({
    palette: {
      mode: colorMode,
    },
  }), [colorMode]);

  useEffect(() => {
    document.documentElement.dataset.theme = signedIn ? colorMode : "light";
    if (signedIn) {
      window.localStorage.setItem("wnp-color-mode", colorMode);
    }
  }, [colorMode, signedIn]);

  const handleColorModeToggle = () => {
    setColorMode((currentMode) => currentMode === "light" ? "dark" : "light");
  };

  // unauthenticated user layout
  if (signedIn === false) {
    return (
      <div className="layout">
        <Topbar
          menuContent={[
            {
              type: "link",
              link: {
                name: "Sign Up",
                path: pagePath.signup,
              },
            },
            {
              type: "link",
              link: {
                name: "Login",
                path: pagePath.login,
              },
            },
          ]}
        />
        {children}
      </div>
    );
  }



  // authenticated user layout

  return (
    <ThemeProvider theme={theme}>
      <div className="layout layout-authenticated">
        <Sidebar />
        <div className="layout-authenticated-content">
        <Topbar
          logoSize="small"
          topbarMiddleContent={<CertSelect />}
          colorMode={colorMode}
          onColorModeToggle={handleColorModeToggle}
          menuContent={[
            {
              type: "button",
              button: {
                name: "Sign Out",
                onClick: handleSignout,
              },
            },
          ]}
        />
        <SurveyPopup isLoggedIn={signedIn} />
        <main className="layout-authenticated-main">{children}</main>
        </div>
      </div>
    </ThemeProvider>
  );
};

export default Layout;
